//
import service from '../../utils/server'
export const getPersonInfo = data => {
    return service({
        url: '/fmUser/login',
        method: 'post',
        data
    })
};

export const fmUserChangeUserPwd = data => {
  return service({
    url: '/fmUser/editPwd',
    method: 'post',
    data
  })
};

// export const fmRoleUserData = data => {
//     return service({
//         url: '/fmRole/getRoleInfoByName',
//         method: 'post',
//         data
//     })
// };

export const fmRoleUserAddData = data => {
    return service({
        url: '/fmRole/addRole',
        method: 'post',
        data
    })
};

export const fmRoleUpdateData = data => {
    return service({
        url: '/fmRole/updateRole',
        method: 'post',
        data
    })
};

export const fmUserQueryList = data => {
    return service({
        url: '/fmUser/getUsersByNoOrName',
        method: 'post',
        data
    })
};

export const fmUserLogin = data => {
    return service({
        url: '/fmUser/login',
        method: 'post',
        data
    })
};
export const fmUserLoginOut = data =>{
  return service({
    url: '/fmUser/out',
    method: 'post',
    data
  })
}
export const queryPowerByMenuId = data => {
  return service({
    url: '/fmPageOp/queryPowerByMenuId',
    method: 'post',
    data
  })
};

//自动登录
export const loginInfo = data => {
  return service({
    url: '/login/info',
    method: 'post',
    data
  })
};

/**
 * 查询用户可操作品牌柜台对应得角色列表
 */
export const getPlantList = data => {
  return service({
    url: '/fm/fmUser/getPlantList',
    method: 'post',
    data
  })
};

//域登录获取url地址
export const authorize = data => {
  return service({
    url: '/api/okta/authorize',
    method: 'get',
    data
  })
};

export const oktaToken = data => {
  return service({
    url: '/api/okta/token',
    method: 'post',
    data
  })
};

//重置密码
export const selectUserForResetPassword = data => {
  return service({
    url: '/fm/fesetPassword/selectUserForResetPassword/'+ data.userNo,
    method: 'post'
  })
};

//发送验证码
export const sendDigit = data => {
  return service({
    url: '/fm/fesetPassword/sendDigit',
    method: 'post',
    data
  })
};

//获取token
export const resetPasswordToken = data => {
  return service({
    url: '/fm/fesetPassword/getResetPasswordToken',
    method: 'post',
    data
  })
};

//重置密码
export const getResetPassword = data => {
  return service({
    url: '/fm/fesetPassword/resetPassword',
    method: 'post',
    data
  })
};

//操作手册查询
export const getOperationManual = data => {
  return service({
    url: '/bd/doc/mgr/detail',
    method: 'post',
    data
  })
};

//操作手册下载
export const getOperationManualDowload = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: '/bd/doc/mgr/file/'+ data.fileCode,
    method: 'post'
  })
};





// WEBPACK FOOTER //
// ./src/view/api/ajax.js